module.exports = __webpack_public_path__ + "img/dummy.11e8b62b.png";